jQuery(function() {

    var modalInstance = null;

    var conventionAnfrageEndpoint = window.pixelpoint.utilities.getAjaxUrl("/index.php?type=1732176051&action=conventionInquiry");

    if($(".convention-anfrage").length == 0)
        return;

    //*
    $(document).on("invalid.zf.abide", function(ev,elem) {
        $(ev.target).closest("form").removeClass("valid").addClass("invalid");
      })
      // field element is valid
      .on("valid.zf.abide", function(ev,elem) {
        $(ev.target).closest("form").removeClass("invalid").addClass("valid");
      })
//*/

    var privateFunctions = {
        submitForm: () => {
            if (modalInstance == null)
                return;
            var instance = modalInstance.element();
            var form = instance.find(".brandenform");
            form.foundation('validateForm');
            if (form.hasClass("valid")) {
                var dataToBeSent = form.serialize();
                var loaderFunctions = instance.find(".loader").data("exposed");
                if (!!loaderFunctions.show) {
                    loaderFunctions.show();
                }
                $.ajax({
                    url: conventionAnfrageEndpoint,
                    type: "POST",
                    data: dataToBeSent
                })
                .done(function(data){
                    modalInstance.close();
                    lity("#anfrage-reply-success");
                })
                .fail(function(e){
                    modalInstance.close();
                    lity("#anfrage-reply-fail");
                })
                .always(function(){
                    if (!!loaderFunctions.hide) {
                        loaderFunctions.hide();
                    }
                })
            }
        }
    };

    $(".convention-anfrage").on("click", function(e){
        e.preventDefault();
        var target = $(e.target).attr("href") || $(this).attr("href");
        if(!!target){
            modalInstance = lity(target);
            Foundation.reInit('equalizer');

            var instance = modalInstance.element();

            instance.find(".submit-form").off("click").on("click", function (e) {
                e.preventDefault();
                privateFunctions.submitForm();
            });
            instance.find(".brandenform a").off("click").on("click", function(e){
                e.stopPropagation();
            });
        }
    });
});  